import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AvatarWithLabel, Box, Button, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Container, Divider } from './styled';
export function MetadataOverviewCard(props) {
    const { lastSync, onOpenSyncDialog } = props;
    return (<Container flexDirection="column" gap="lg" p="xl" mx="2xl" mb="xl" bg="background.100" borderRadius="md">
      <AvatarWithLabel title={t({ message: 'Metadata Overview', comment: 'HubSpot metadata: metadata overview title' })} size="sm" appearance="info" solid shape="square">
        <Falcon icon="tags"/>
      </AvatarWithLabel>

      <Typography $appearance="100" $fontSize="tiny">
        <Trans comment="HubSpot metadata: overview card description">
          Review and update your document&apos;s metadata to keep it organised and easy to find.
        </Trans>
      </Typography>

      <Divider />

      <Box alignItems="center" flexDirection="row" gap="md" justifyContent="space-between" style={{ flexWrap: 'wrap' }}>
        <Button size="xs" appearance="secondary" onClick={onOpenSyncDialog}>
          <Falcon icon="hubspot" sourceConfig={{ family: 'classic', style: 'brands' }}/>
          <Trans comment="HubSpot metadata: open sync dialog">Sync to HubSpot</Trans>
        </Button>
        {lastSync && (<Typography $appearance="100" $fontSize="tiny">
            {lastSync}
          </Typography>)}
      </Box>
    </Container>);
}
